import type { DataSource } from "../../../types/DataSource";
import ApiService from "../../../services/ApiService";
import FeatureService from "../../../services/FeatureService";
import { useModalManager } from "../../../components/modal/ModalManager";
import GenericFailureModal from "../../GenericFailureModal";
import { TextAndIconButton } from "../../../components/button/Button";
import { useTranslation } from "../../../state/i18n";
import { createMemo, getOwner, runWithOwner, Show, untrack, type VoidComponent } from "solid-js";
import { createWritableMemo } from "@solid-primitives/memo";

type RefreshDataSourceButtonProps = {
  dataSource: DataSource;
};
export const RefreshDataSourceButton: VoidComponent<RefreshDataSourceButtonProps> = (props) => (
  <Show when={FeatureService.hasFeature("MANUAL_DATASOURCES")}>
    <Inner {...props} />
  </Show>
);

const Inner: VoidComponent<RefreshDataSourceButtonProps> = (props) => {
  const owner = getOwner();
  const { t } = useTranslation();
  const { open } = useModalManager();
  const dataSourceStatusQuery = createMemo(() => ApiService.getDataSourceStatus(props.dataSource.id));
  const [isLoading, setIsLoading] = createWritableMemo(() => dataSourceStatusQuery().data?.inProgress ?? false);

  return (
    <Show when={FeatureService.hasFeature("MANUAL_DATASOURCES")}>
      <TextAndIconButton
        variant="primary"
        size="large"
        icon="refresh"
        text={t(($) => $.DATASOURCES_GOOGLESHEETS_ACTION_REFRESH)}
        loading={isLoading()}
        onClick={() => {
          runWithOwner(owner, () => {
            setIsLoading(true);
            untrack(() => {
              ApiService.scheduleDataSource().mutate(props.dataSource.id, {
                onError: (err) =>
                  open({
                    content: () => <GenericFailureModal error={err} />,
                  }),
                onSettled: () => setIsLoading(false),
              });
            });
          });
        }}
      />
    </Show>
  );
};
